import load from 'loadjs';
import loadConfiguration from 'ggApp/utils/configuration/configuration';

const { BRAZE_SDK_STATIC } = loadConfiguration();

const BRAZE_SDK_BUNDLE_ID = 'brazeBundleId';

export const loadBrazeSdk = () => {
    const addAttribute = (_, scriptElement) => {
        // eslint-disable-next-line no-param-reassign
        scriptElement.dataset.main = 'braze-js';
    };
    return new Promise((resolve, reject) => {
        if (load.isDefined(BRAZE_SDK_BUNDLE_ID)) {
            resolve();
            return;
        }
        load(BRAZE_SDK_STATIC, BRAZE_SDK_BUNDLE_ID, {
            error: reject,
            success: resolve,
            before: addAttribute,
        });
    });
};

export const prepareBrazeClient = () => {
    /* eslint-disable */
    (function() {
        window.appboy = {};
        window.appboyQueue = [];
        for (
            var s = 'initialize destroy getDeviceId toggleAppboyLogging getCachedContentCards setLogger openSession changeUser requestImmediateDataFlush requestFeedRefresh subscribeToFeedUpdates requestContentCardsRefresh subscribeToContentCardsUpdates logCardImpressions logCardClick logCardDismissal logFeedDisplayed logContentCardsDisplayed logInAppMessageImpression logInAppMessageClick logInAppMessageButtonClick logInAppMessageHtmlClick subscribeToNewInAppMessages subscribeToInAppMessage removeSubscription removeAllSubscriptions logCustomEvent logPurchase isPushSupported isPushBlocked isPushGranted isPushPermissionGranted registerAppboyPushMessages unregisterAppboyPushMessages trackLocation stopWebTracking resumeWebTracking wipeData ab ab.DeviceProperties ab.User ab.User.Genders ab.User.NotificationSubscriptionTypes ab.User.prototype.getUserId ab.User.prototype.setFirstName ab.User.prototype.setLastName ab.User.prototype.setEmail ab.User.prototype.setGender ab.User.prototype.setDateOfBirth ab.User.prototype.setCountry ab.User.prototype.setHomeCity ab.User.prototype.setLanguage ab.User.prototype.setEmailNotificationSubscriptionType ab.User.prototype.setPushNotificationSubscriptionType ab.User.prototype.setPhoneNumber ab.User.prototype.setAvatarImageUrl ab.User.prototype.setLastKnownLocation ab.User.prototype.setUserAttribute ab.User.prototype.setCustomUserAttribute ab.User.prototype.addToCustomAttributeArray ab.User.prototype.removeFromCustomAttributeArray ab.User.prototype.incrementCustomUserAttribute ab.User.prototype.addAlias ab.User.prototype.setCustomLocationAttribute ab.InAppMessage ab.InAppMessage.SlideFrom ab.InAppMessage.ClickAction ab.InAppMessage.DismissType ab.InAppMessage.OpenTarget ab.InAppMessage.ImageStyle ab.InAppMessage.TextAlignment ab.InAppMessage.Orientation ab.InAppMessage.CropType ab.InAppMessage.prototype.subscribeToClickedEvent ab.InAppMessage.prototype.subscribeToDismissedEvent ab.InAppMessage.prototype.removeSubscription ab.InAppMessage.prototype.removeAllSubscriptions ab.InAppMessage.prototype.closeMessage ab.InAppMessage.Button ab.InAppMessage.Button.prototype.subscribeToClickedEvent ab.InAppMessage.Button.prototype.removeSubscription ab.InAppMessage.Button.prototype.removeAllSubscriptions ab.SlideUpMessage ab.ModalMessage ab.FullScreenMessage ab.HtmlMessage ab.ControlMessage ab.Feed ab.Feed.prototype.getUnreadCardCount ab.ContentCards ab.ContentCards.prototype.getUnviewedCardCount ab.Card ab.Card.prototype.dismissCard ab.ClassicCard ab.CaptionedImage ab.Banner ab.ControlCard ab.WindowUtils display display.automaticallyShowNewInAppMessages display.showInAppMessage display.showFeed display.destroyFeed display.toggleFeed display.showContentCards display.hideContentCards display.toggleContentCards sharedLib'.split(
                    ' ',
                ),
                i = 0;
            i < s.length;
            i++
        ) {
            for (var m = s[i], k = window.appboy, l = m.split('.'), j = 0; j < l.length - 1; j++)
                k = k[l[j]];
            k[l[j]] = new Function(
                'return function ' +
                    m.replace(/\./g, '_') +
                    '(){window.appboyQueue.push(arguments); return true}',
            )();
        }
        /* eslint-enable */
        window.appboy.getUser = () => {
            return new window.appboy.ab.User();
        };
        window.appboy.getCachedFeed = () => {
            return new window.appboy.ab.Feed();
        };
    })();
};
